import SimplePopup from './SimplePopup';
import type SimplePopupProps from './SimplePopup';

export default SimplePopup;
export type { SimplePopupProps };
